import React from 'react'

import { Layout, SectionTitle, ItemTitle, Header } from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        title={data.title}
        site={data.site}
        state="develop"
        slug={data.slug + '/develop/'}
      />
      <Layout
        category={data.category}
        changelog={changelog[data.title].changelog}
        description={data.description}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        <SectionTitle> Classes</SectionTitle>
        <p>
          Padding follows Currency’s use of BEM naming. To specify padding on
          one side of an element, include where it should appear, -top, -bottom,
          -left or -right, followed by the size modifier.
        </p>
        <ItemTitle>Top Padding</ItemTitle>
        <table class="table">
          <thead>
            <th>Class</th>
            <th>Value (px)</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="table__code">.l-padding-top--none</span>
              </td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-top--xxxsmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-top--xxsmall</span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-top--xsmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-top--small</span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-top--medium</span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-top--large</span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-top--xlarge</span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-top--xxlarge</span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-top--xxxlarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Bottom Padding</ItemTitle>
        <table class="table">
          <thead>
            <th>Class</th>
            <th>Value (px)</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="table__code">.l-padding-bottom--none</span>
              </td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-bottom--xxxsmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-bottom--xxsmall</span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-bottom--xsmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-bottom--small</span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-bottom--medium</span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-bottom--large</span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-bottom--xlarge</span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-bottom--xxlarge</span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-bottom--xxxlarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Left Padding</ItemTitle>
        <table class="table">
          <thead>
            <th>Class</th>
            <th>Value (px)</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="table__code">.l-padding-left--none</span>
              </td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-left--xxxsmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-left--xxsmall</span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-left--xsmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-left--small</span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-left--medium</span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-left--large</span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-left--xlarge</span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-left--xxlarge</span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-left--xxxlarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Right Padding</ItemTitle>
        <table class="table">
          <thead>
            <th>Class</th>
            <th>Value (px)</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="table__code">.l-padding-right--none</span>
              </td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-right--xxxsmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-right--xxsmall</span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-right--xsmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-right--small</span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-right--medium</span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-right--large</span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-right--xlarge</span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-right--xxlarge</span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-right--xxxlarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Vertical Padding</ItemTitle>
        <table class="table">
          <thead>
            <th>Class</th>
            <th>Value (px)</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="table__code">.l-padding-vertical--none</span>
              </td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-vertical--xxxsmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-vertical--xxsmall</span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-vertical--xsmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-vertical--small</span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-vertical--medium</span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-vertical--large</span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-vertical--xlarge</span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-vertical--xxlarge</span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-vertical--xxxlarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Horizontal Padding</ItemTitle>
        <table class="table">
          <thead>
            <th>Class</th>
            <th>Value (px)</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="table__code">.l-padding-horizontal--none</span>
              </td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-horizontal--xxxsmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-horizontal--xxsmall</span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-horizontal--xsmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-horizontal--small</span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-horizontal--medium</span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-horizontal--large</span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-horizontal--xlarge</span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-horizontal--xxlarge</span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-padding-horizontal--xxxlarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
      </Layout>
    </>
  )
}

export const code = {
  top: `<div class="l-padding-top--xxsmall"></div>
`,
  bottom: `<div class="l-padding-bottom--xxsmall"></div>
`,
  left: `<div class="l-padding-left--xxsmall"></div>
`,
  right: `<div class="l-padding-right--xxsmall"></div>
`,
}
